"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TimelineConversationAsync;

var _AsyncComponent = _interopRequireDefault(require("customer-data-ui-utilities/component/AsyncComponent"));

var _react = _interopRequireDefault(require("react"));

var _AsyncComponentErrorHandler = _interopRequireDefault(require("crm_ui/utils/AsyncComponentErrorHandler"));

var _TimelineCardSkeleton = _interopRequireDefault(require("crm_ui/timeline/components/generic/TimelineCardSkeleton"));

function requirement(done) {
  import(
  /* webpackChunkName: "timeline-components-events-conversation-TimelineConversationAsync" */
  './TimelineConversation').then(function (module) {
    return done(module.default);
  }, (0, _AsyncComponentErrorHandler.default)('timeline'));
}

function TimelineConversationAsync(props) {
  return _react.default.createElement(_AsyncComponent.default, {
    props: props,
    loadingContent: _react.default.createElement(_TimelineCardSkeleton.default, {
      loadingMessage: "profileContentTimeline.loadingEvent.conversation"
    }),
    requirement: requirement
  });
}

module.exports = exports.default;